import * as React from 'react';
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

import './style.scss';

// TODO: set types properly for everything in this component.
interface ISortableProps {
  sortableItems: any[];
  className?: string;
  onSortEnd: (sortedList: any[]) => void;
}

const DragHandle = SortableHandle(() => <div className="sortable__drag-handle" />);

const SortableItem = SortableElement(
  (props: { value: any }): JSX.Element => (
    <li className="sortable__element">
      <DragHandle />
      {props.value}
    </li>
  )
);

const SortableList = SortableContainer(
  (props: { items: any }): JSX.Element => (
    <ul className="sortable">
      {props.items.map((value, index) => (
        <SortableItem key={`item-${index}`} index={index} value={value} />
      ))}
    </ul>
  )
);

export default class SortableComponent extends React.Component<ISortableProps, {}> {
  onSortEnd = ({ oldIndex, newIndex }) => {
    const sortedItems = arrayMove(this.props.sortableItems, oldIndex, newIndex);

    this.props.onSortEnd(sortedItems);
  };

  render() {
    return (
      <SortableList
        useDragHandle={true}
        items={React.Children.toArray(this.props.children)}
        onSortEnd={this.onSortEnd}
      />
    );
  }
}
